import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { ILogName, NRAttributes, logCodeMapping } from '../../types/nr-attributes-type';
import ScriptLoader from './script-loader';
import { URLS } from '../../config/api-config';
import { isMobile } from './mobile-utils';
import { WindowType } from '../../types/global-window-type';
import { getChatConfig } from './chat-config-utils';

declare const window: WindowType;

export const logMapping = (logName: ILogName): NRAttributes => {
  const { locale, env } = getChatConfig();

  const commonAttributes = {
    deploymentName: `chat-anywhere-miaw-${locale}-chat`,
    locale,
    deviceType: isMobile() ? 'mobile' : 'desktop',
    env: env?.includes('production') ? 'production' : 'dev',
    logCode: logCodeMapping[logName],
    logName,
    miaw: true,
  };
  switch (logName) {
    case 'CA_FIRE_IMPRESSION_ERROR':
      return { ...commonAttributes, logLevel: 'error', message: 'CA: Error occured in Fire Impression' };
    case 'CA_PAGE_PROPERTIES_ERROR':
      return { ...commonAttributes, logLevel: 'error', message: 'CA: Error occured in computing page properties' };
    case 'CA_EVENTS_ERROR':
      return { ...commonAttributes, logLevel: 'error', message: 'CA: Error in saleforce Events' };
    case 'CA_OUTSIDE_BUSINESS_HR':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Outside Business Hour' };
    case 'CA_AGENT_UNAVAILABLE':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Agent Unavailable' };
    case 'CA_CHAT_ESTABLISHED':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat Established' };
    case 'CA_CHAT_REQUEST_SUCCESS':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat Request Success' };
    case 'CA_AGENT_CONNECTION_LOST':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat Agent Connection lost' };
    case 'CA_HELP_BUTTON_CLICKED':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Help Button Clicked' };
    case 'CA_CHAT_ENDED_BY_USER':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat ended by user' };
    case 'CA_CHAT_ENDED_BY_AGENT':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat ended by agent' };
    case 'CA_DISABLED_CLICK':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Disabled CTA clicked' };
    case 'CA_CHANNEL_PROVIDER_ENTRY_NOT_FOUND':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Channer provider Entry not found' };
    case 'CA_BUSINESS_HR_END':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Business Hour ending' };
    case 'CA_HIDE_ON_BUSINESS_HR_END':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: Chat button hidden on business hr end' };
    case 'CA_USER_LASTNAME_EMPTY':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: LoggedIn User LastName Empty' };
    case 'CA_USER_FIRSTNAME_EMPTY':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: LoggedIn User FirstName Empty' };
    case 'CA_USER_FIRSTNAME_EMPTY_UPDATED_WITH_EMAILID':
      return {
        ...commonAttributes,
        logLevel: 'info',
        message: 'CA: LoggedIn User FirstName Empty and updated with EmailId',
      };
    case 'CA_USER_LASTNAME_EMPTY_UPDATED_WITH_EMAILID':
      return {
        ...commonAttributes,
        logLevel: 'info',
        message: 'CA: LoggedIn User lastName Empty and updated with EmailId',
      };
    case 'CA_USER_LASTNAME_EMPTY_UPDATED_WITH_FIRSTNAME':
      return {
        ...commonAttributes,
        logLevel: 'info',
        message: 'CA: LoggedIn User LastName Empty and updated with FirstName',
      };
    case 'CA_USER_EMAIL_EMPTY':
      return { ...commonAttributes, logLevel: 'info', message: 'CA: LoggedIn User Email Empty' };
    case 'CA_ERROR':
    default:
      return { ...commonAttributes, logLevel: 'error', message: 'CA: Error occured ' };
  }
};

const CA_LOG_KEY = 'ca-log-key';

export const getNRId = () => {
  const id = Cookies.get(CA_LOG_KEY);
  return id;
};

export const setNRId = () => {
  if (!getNRId()) {
    const id = uuidv4();
    Cookies.set(CA_LOG_KEY, id);
  }
};

export const removeNRId = () => {
  Cookies.remove(CA_LOG_KEY);
};

export const initNR = () => {
  const { env } = getChatConfig();
  if (env?.includes('production') || env?.includes('sandbox')) {
    setNRId();
    if (window && window.newrelic) {
      console.info('NR already initialized');
      return;
    }
    ScriptLoader(URLS.NEW_RELIC)
      .then(() => {
        console.info('NR Script loaded');
      })
      .catch((err) => {
        console.error('NR Init Error', err);
      });
  } else {
    console.info('NR not initialzed for Dev ENV');
  }
};

export const logNR = (logCode: ILogName, additionalInfo?: unknown) => {
  const { env } = getChatConfig();
  if (env?.includes('production') || env?.includes('sandbox')) {
    let attributes = logMapping(logCode);
    const caLogKey = getNRId();
    if (typeof additionalInfo in ['boolean', 'string', 'number']) {
      attributes = { ...attributes, additionalInfo };
    } else if (typeof additionalInfo === 'object') {
      attributes = { ...attributes, ...additionalInfo };
    }

    console.info(logCode, { attributes }, caLogKey);
    // set the event name in NR
    const pageAction = 'chat_anywhere';
    if (window && window.newrelic) {
      window.newrelic.addPageAction(pageAction, { ...attributes, caLogKey });
    }
  } else console.info('NR Logging disabled for DEV environment ');
};
